import { render } from "./CustomizedSubscriptions.vue?vue&type=template&id=268e8c93&scoped=true"
const script = {}

import "./CustomizedSubscriptions.vue?vue&type=style&index=0&id=268e8c93&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-268e8c93"]])

export default __exports__